import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  sidebarMenu: [],
  isLoading: false,
  error: null,
  lastFetched: null
};

export const sidebarSlice = createSlice({
  name: 'sidebar',
  initialState,
  reducers: {
    setSidebarMenu: (state, action) => {
      state.sidebarMenu = action.payload;
      state.isLoading = false;
      state.error = null;
      state.lastFetched = Date.now();
    },
    setSidebarLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setSidebarError: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    clearSidebarMenu: (state) => {
      state.sidebarMenu = [];
      state.isLoading = false;
      state.error = null;
      state.lastFetched = null;
    }
  },
});

export const { 
  setSidebarMenu, 
  setSidebarLoading, 
  setSidebarError, 
  clearSidebarMenu 
} = sidebarSlice.actions;

export default sidebarSlice.reducer;
